const ArabicLanguageMap = {
  guidenotupdated:
    'هذه الترجمة المجتمعية لم يتم تحديثها إلى اخر اصدار من ستوريبوك بعد. ساعدنا في تحديثها عن طريق اتباع التغييرات في دليل العربية في هذه الترجمة',
  pullrequestmessage: 'طلبات Pull مرحب بها',
};

export default ArabicLanguageMap;
